// useTheme.ts — hook returning { theme, resolvedTheme, setTheme }.
// Plan ref: 06-00-PLAN §interfaces.

import { useContext } from 'react';
import { ThemeContext, type ThemeContextValue } from './ThemeProvider';

export function useTheme(): ThemeContextValue {
  const ctx = useContext(ThemeContext);
  if (!ctx) {
    throw new Error('useTheme must be used inside <ThemeProvider>');
  }
  return ctx;
}
